import React, { FC, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import helpIcon from 'assets/img/helpIcon.svg';
import CommonTransComponents from 'i18n/CommonTransComponents';

import './Announcement.scss';

export interface AnnouncementProps {}

const Announcement: FC<AnnouncementProps> = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  if (!open) {
    return null;
  }

  return (
    <div className="enkrateia-dashboard-announcement">
      <div className="no-announcements">{t('pages.dashboard.announcements.noAnnouncements')}</div>
      <div className="hint">
        <img src={helpIcon} alt="?" className="help-icon" />
        <Trans t={t} i18nKey="pages.dashboard.announcements.didYouKnow" components={CommonTransComponents}></Trans>
      </div>
      <button className="close" onClick={() => setOpen(false)}>
        ×
      </button>
    </div>
  );
};

export default Announcement;
